import React from "react";
import {
    Chord,
    Tone
} from "../../model/core";
import { isKnownChordFamily } from "../../model/chords";
import { ApiFactory } from "../../ApiClient";
import { getToneSynesthesiaColor } from "../../render/renderUtils";
import {
    keybindingsGlobalResume,
    keybindingsGlobalSuspend
} from "../../keybindings/dispatcher";


const API = ApiFactory.create();

export function ChordSelectionDialog({
    chord,
    discardCB,
    acceptCB,
    removeCB
}: {
    chord?: Chord,
    discardCB: () => void,
    acceptCB: (chord: Chord) => void,
    removeCB: () => void
}) {
    const [chordInput, setChordInput] = React.useState(chord ? chord.root.getName() + ' ' + chord.family : '');
    const [validInput, setValidInput] = React.useState(false);
    const [chordOutput, setChordOutput] = React.useState<Chord | null>(null);

    const classes: string[] = [];
    if (!validInput) {
        classes.push('ryd--input-invalid');
    }

    return (<>
        <div
            style={{ display: 'inline-flex', flexDirection: 'row' }}
            className="chord-input-dialog--wrapper">
            <div style={{ display: 'inline-flex', flexDirection: 'column' }} >
                <input
                    className={classes.join(' ')}
                    style={{ width: '8em' }}
                    value={chordInput}
                    onFocus={keybindingsGlobalSuspend}
                    onBlur={keybindingsGlobalResume}
                    onChange={(e) => {
                        const [r, f] = e.target.value.split(' ');
                        setChordInput(e.target.value);

                        // pre checks, since we still go to the server.
                        const invalidTone = !Tone.isValid(r);
                        const invalidFamily = !isKnownChordFamily(f);

                        if (invalidTone || invalidFamily) {
                            setValidInput(false);
                            setChordOutput(null);
                            return;
                        }

                        /* FIXME:   are we handling error cases corretly here?
                                    i.e. can't there be a case where the server doesn't recognize the chord?
                        */
                        API.getChord(new Chord(r, f)).then((c) => {
                            setValidInput(true);
                            setChordOutput(c);
                        });
                    }} />
                {(validInput && chordOutput) && <div className="chord-input-dialog--output">
                    {chordOutput.tones
                        .map((tone, i) => tone)
                        .map((t, i) => <div
                            key={i}
                            style={i > 0 ? {} : { borderRight: `10px solid var(${getToneSynesthesiaColor(t)})` }}
                        >{t.getName()}</div>)}
                </div>}
            </div>

            <div
                style={{ display: 'inline-flex', flexDirection: 'column' }}
                className="chord-input-dialog--controls">
                <button disabled={!validInput || !chordOutput}
                    onClick={(e) => {
                        if (!chordOutput) return;
                        acceptCB(chordOutput);
                    }}>Accept</button>
                <button onClick={removeCB}>Remove</button>
                <button onClick={discardCB}>Close</button>
            </div>
        </div>
    </>);
}